import { z } from "zod";

export const WIDGET_COLORS = [
  "blue",
  "green",
  "red",
  "yellow",
  "purple",
  "orange",
  "tomato",
  "indigo",
] as const;

// Schema para a configuração do chat widget
export const AgentDeployChatWidgetConfigSchema = z
  .object({
    color: z.enum(WIDGET_COLORS),
    greeting_message: z.string().min(2),
  })
  .catchall(z.unknown()); // Permite propriedades adicionais com [key: string]: unknown

// Schema principal para o AgentDeployChatWidget
export const AgentDeployChatWidgetSchema = z.object({
  organization_id: z.string().length(36).optional(),
  agent_id: z.string().length(36),
  disabled: z.boolean().optional(),
  key: z.string().max(64),
  // AI-955: a widget must declare at least one allowed origin. An empty list
  // used to mean "allow any origin" — a security gap blocked on the server too.
  allowed_origins: z.array(
    z.url()
      .refine((val) => val.startsWith("http://") || val.startsWith("https://"), {
          error: "Origin must start with http:// or https://"
    })
  ).min(1),

  configuration: AgentDeployChatWidgetConfigSchema,
  created_at: z.iso.datetime().optional(),
  updated_at: z.iso.datetime().optional(),
});

// Schema para criação (omitindo campos que podem ser gerados automaticamente)
export const CreateAgentDeployChatWidgetSchema = AgentDeployChatWidgetSchema.omit({
  agent_id: true,
  key: true,
  organization_id: true,
  disabled: true,
  created_at: true,
  updated_at: true,
});

// Schema para atualização (todos os campos opcionais exceto id)
export const UpdateAgentDeployChatWidgetSchema = AgentDeployChatWidgetSchema.partial().omit({
  key: true,
  organization_id: true,
  created_at: true,
  updated_at: true,
  agent_id: true,
});

// Tipos TypeScript derivados dos schemas
export type AgentDeployChatWidgetConfig = z.infer<typeof AgentDeployChatWidgetConfigSchema>;
export type AgentDeployChatWidget = z.infer<typeof AgentDeployChatWidgetSchema>;
export type CreateAgentDeployChatWidget = z.infer<typeof CreateAgentDeployChatWidgetSchema>;
export type UpdateAgentDeployChatWidget = z.infer<typeof UpdateAgentDeployChatWidgetSchema>;
